"use client";
import React from "react";
import BUIContext from "../components/BUIProvider/BUIProvider.context.js";
var reactUseIdAvailable = typeof React.useId === "function";
export var useGetNextId = function () {
    var _a = React.useContext(BUIContext), idRef = _a.idRef, providerCount = _a.providerCount, providerId = _a.providerId;
    return React.useCallback(function () {
        var contextPrefix = providerCount > 0 ? "c".concat(providerCount, "-") : "";
        if (providerId)
            contextPrefix = "".concat(providerId, "-").concat(contextPrefix);
        return "__bui-".concat(contextPrefix).concat(++idRef.current);
    }, [idRef, providerCount, providerId]);
};
var useId = function (id) {
    var getNextId = useGetNextId();
    if (id !== undefined)
        return id;
    if (reactUseIdAvailable) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return React.useId();
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useMemo(function () {
        if (id)
            return id;
        return getNextId();
    }, [getNextId, id]);
};
export default useId;
